const security = {
  roles: {
    admin: 'admin',
    screenManager: 'screen_manager',
  },
}

const constants = {
  app: {
    meta: {
      name: 'Screen Flow',
      subName: 'Player',
      copyright: `Copyright \u00A9 2024 by Screen Flow`,
    },
  },
  auth: {
    namespaces: {
      root: 'https://screenflow.co.uk',
      roles: `https://screenflow.co.uk/roles`,
      uid: `https://screenflow.co.uk/uid`,
    },
  },
  api: {
    baseUrl: `${process.env.VUE_APP_API_BASE_URL}`,
  },
  websockets: {
    baseUrl: `${process.env.VUE_APP_WS_BASE_URL}`,
    namespaces: {
      root: '/ws',
      pairing: `player/pairing`,
      screen: `player/screen`,
    },
  },
  nav: {
    unauthorized: {
      name: 'unauthorized',
      meta: {
        title: 'Unauthorized',
        subtitle: '',
        icon: 'mdi-alert-circle-outline',
        breadcrumbs: ['Unauthorized'],
      },
    },
    default: {
      name: 'default',
      meta: {
        title: 'Please wait...',
        subtitle: '',
        icon: 'mdi-clock-outline',
        breadcrumbs: [],
        rbac: [security.roles.screenManager, security.roles.admin],
      },
    },
    pairing: {
      name: 'pairing',
      meta: {
        title: 'Pair Display',
        subtitle: '',
        icon: 'mdi-qrcode-scan',
        breadcrumbs: ['Pair'],
        rbac: [security.roles.screenManager, security.roles.admin],
      },
    },
    screen: {
      name: 'screen',
      meta: {
        title: 'Screen',
        subtitle: '',
        icon: 'mdi-television',
        breadcrumbs: ['Screen'],
        rbac: [security.roles.screenManager, security.roles.admin],
      },
    },
  },
  display: {
    status: {
      online: {
        title: 'Online',
        icon: 'mdi-lightning-bolt',
        color: 'success',
        id: 'online',
      },
      uploading: {
        title: 'Uploading',
        icon: 'mdi-cloud-upload',
        color: 'info',
        id: 'uploading',
      },
      casting: {
        title: 'Casting',
        icon: 'mdi-cast-connected',
        color: 'info',
        id: 'casting',
      },
      blanked: {
        title: 'Blanked',
        icon: 'mdi-television-off',
        color: 'grey-darken-3',
        id: 'blanked',
      },
      offline: {
        title: 'Offline',
        icon: 'mdi-cloud-off-outline',
        color: 'error',
        id: 'offline',
      },
      unknown: {
        title: 'Unknown',
        icon: 'help-circle',
        color: 'grey-darken-3',
        id: 'unknown',
      },
    },
    actions: {
      manageContent: {
        title: 'Manage Content',
        icon: 'mdi-file-cog',
      },
    },
  },
};

export default constants;